/**
 * m3 echo Frontend - Admin Route Component
 *
 * Wrapper component that ensures only admin users can access certain routes.
 * Redirects non-admin users to the dashboard.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { ProtectedRoute } from './ProtectedRoute';

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const user = useAuthStore((state) => state.user);

  // First ensure user is authenticated via ProtectedRoute
  // Then check if user is admin
  if (!user?.is_admin) {
    // Not an admin, redirect to dashboard
    return <Navigate to="/" replace />;
  }

  // User is admin, show the admin content
  return <>{children}</>;
};

/**
 * Combined ProtectedRoute + AdminRoute wrapper
 * Use this for admin-only pages
 */
export const ProtectedAdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  return (
    <ProtectedRoute>
      <AdminRoute>{children}</AdminRoute>
    </ProtectedRoute>
  );
};
